import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5kF4TVATRHUgfc3JJrLp7j/Logo-K.svg';

/**
 * Brand mark: the exact squared "K" logo file, served from Magic Patterns'
 * own CDN. Using the permanent CDN URL (instead of hotlinking a third-party
 * domain) keeps this pixel-accurate to the source file and reliable across
 * networks/devices.
 */
export function BrandMark({
  className
}: {
  className?: string;
}) {
  return <img src={LOGO_URL} alt="Kusminov" className={`${className ?? ''} brand-mark-image`} data-id="element-65" data-mp="1m6oo96mr4ldn" />;
}